<template>
  <div style="height: auto;">
    <div class="phone-selector-container-mobile" v-if="device">
      <div class="col" style="margin-bottom: 2rem;" v-if="$whitelabel.showLogo()">
        <img :src="require('../../../assets/sqrql_logo.png')" width="160px" height="160px">
      </div>
      <div class="col-12" style="margin-top: 3rem; margin-bottom: 3rem;" v-if="processing">
        <b-spinner variant="teal" label="Spinning"></b-spinner>
      </div>
      <div class="col-12" style="margin-top: 3rem; margin-bottom: 3rem;" v-else>
        <div class="col-12" style="min-height: 60px;">
          <b-alert variant="warning" :show="isAlert">
            {{ alert }} <br />
            {{ upBandwidth }} <br />
            {{ downBandwidth }}
          </b-alert>
        </div>
        <div class="col-10 offset-1" style="margin-top: 2rem;">
          <b-button variant="primary" @click="test" block style="background-color: #009AB1; border-color: #009AB1;"">Test</b-button>
        </div>
      </div>
    </div>
    <div class="phone-selector-container-mobile" v-else>
      <link rel="stylesheet" :href="require('../../../assets/css/vue-select.css')">
      <div class="col" style="margin-bottom: 2rem;" v-if="$whitelabel.showLogo()">
        <img :src="require('../../../assets/sqrql_logo.png')" width="160px" height="160px">
      </div>
      <div class="col-12" style="margin-top: 3rem; margin-bottom: 3rem;" v-if="processing">
        <b-spinner variant="teal" label="Spinning"></b-spinner>
      </div>
      <div class="col-12" v-else>
        <div class="col">
          <h4>{{ $whitelabel.isWhiteLabel() ? 'Select a Softphone' : 'Select a FracTELfone' }}</h4>
        </div>
        <div class="col-12" style="margin-top: 3rem; margin-bottom: 8rem;">
          <v-select
            v-model="deviceId"
            v-bind:options="devices"
            @input="deviceSelect"
            />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import vSelect from 'vue-select'

  import jQuery from 'jquery'
  import FSRTC from 'FSRTC'
  import jsonRpcClient from 'jsonrpcclient'
  import verto from 'verto'

  export default {
    name: 'bandwidth',
    components: {
      'v-select': vSelect
    },
    mounted: async function () {
      var self = this
      try {
        self.processing = true
        var response = await axios.get(`${process.env.FONESTORM_API}/devices`, { headers: { token: localStorage.getItem('fonestorm-token') } })
        response.data.devices.forEach((device) => {
          if (device.type === 'fractelfone' || device.type === 'webrtc device') {
            self.devices.push({
              label: device.name,
              code: device.id
            })
          }
        })
        self.processing = false
      } catch (error) {
        self.processing = false
        if (error.response.status === 401) {
          self.$router.push({ name: 'Login' })
        }
      }
    },
    data () {
      return {
        verto,
        FSRTC,
        jsonRpcClient,
        processing: false,
        isAlert: false,
        alert: '',
        upBandwidth: '',
        downBandwidth: '',
        deviceId: null,
        device: null,
        devices: [],
        hostname: 'webrtc.fractel.net',
        websocket_url: 'wss://webrtc.fractel.net:8082',
        vertoHandle: null
      }
    },
    methods: {
      test: async function () {
        var self = this
        self.processing = true
        // var bandwidthTestData = null
        var bytesToSendAndReceive = 1024 * 256
        self.vertoHandle.rpcClient.speedTest(bytesToSendAndReceive, function(event, data) {
          // These values are in kilobits/sec.
          var upBand = Math.ceil(data.upKPS)
          var downBand = Math.ceil(data.downKPS)
          self.alert = '[BANDWIDTH TEST]'
          self.upBandwidth = 'Up: ' + upBand + ' kb'
          self.downBandwidth = 'Down: ' + downBand + ' kb'
          self.isAlert = true
          self.processing = false
          // Store the results for later.
          // bandwidthTestData = data
        })
      },
      deviceSelect: async function () {
        var self = this
        try {
          self.processing = true
          if (self.deviceId) {
            var response = await axios.get(`${process.env.FONESTORM_API}/devices/${self.deviceId.code}/verto`, { headers: { token: localStorage.getItem('fonestorm-token') } })
            self.device = response.data.device
          }

          self.vertoHandle = new jQuery.verto({
            login: `${self.device.username}@${self.hostname}`,
            passwd: self.device.password,
            socketUrl: self.websocket_url,
            tag: 'webcam',
            // ringer: 'ringer',
            // localTag: localTag,
            // ringFile: require('../../../assets/sounds/bell_ring2.wav'),
            videoParams: {},
            audioParams: {
              googAutoGainControl: false,
              googNoiseSuppression: false,
              googHighpassFilter: false
            },
            iceServers: false
          }, {})

          self.processing = false
        } catch (error) {
          self.processing = false
          if (error.response.status === 401) {
            self.$router.push({ name: 'Login' })
          }
        }
      }
    }
  }
</script>

<style scopped>
.phone-selector-container-mobile {
  background-color: white;
  padding: 20px !important;
  margin: 0 auto 0 auto !important;
  height: 100%;
  width: 100%;
  overflow: hidden;
  text-align: center !important;
}

.vs__dropdown-menu {
  max-height: 200px !important;
}

.vs__dropdown-option--highlight {
  background-color: #009AB1 !important;
}

.text-teal {
  color: #009AB1;
}
</style>
